//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.CustomViewSettingsBuilder.js";
import "../Drawings/Drawings.MultipleViewPlacementBuilder.js";
import "../Drawings/Drawings.OvtBuilder.js";
import "../Drawings/Drawings.ViewScaleBuilder.js";
import "../Drawings/Drawings.ViewStyleBuilder.js";
import "../no/Preferences.js";
let d=[[[0,"AssociativeAlignment",1,0],[0,"AutoScale",1,0],[0,"BackView",1,0],[0,"BaseView",1,0],[0,"BottomView",1,0],[0,"CenterLines",1,0],[0,"CrosshatchInheritedSectionViews",1,0],[1,"CustomViewSettingsBuilder",0,"Drawings.CustomViewSettingsBuilder",0],[0,"ExtractedEdges",1,0],[0,"FrontView",1,0],[0,"HiddenLineColor",1,0],[0,"HiddenLineFont",1,0],[0,"HiddenLineWidth",1,0],[0,"HiddenLines",1,0],[0,"IgnoreTitleBlock",1,0],[0,"InheritPMI",1,0],[0,"InheritPmiOntoDrawing",1,0],[0,"IsometricView",1,0],[0,"LeftView",1,0],[0,"LockMethod",1,0],[0,"MarginBetweenViews",1,0],[0,"MarginToBorder",1,0],[1,"MultipleViewPlacement",0,"Drawings.MultipleViewPlacementBuilder",0],[0,"OptimizeSettings",1,0],[1,"OrientViewTool",0,"Drawings.OvtBuilder",0],[0,"Part",1,"Part",0],[0,"PlacementOption",1,0],[0,"PmiDimensionFromRevolved",1,0],[0,"PmiTypes",1,0],[0,"Resolution",1,0],[0,"RightView",1,0],[0,"Silhouettes",1,0],[0,"SnapShot",1,1],[0,"SpecialBaseView",1,0],[0,"Tolerance",1,0],[0,"TopView",1,0],[0,"TrimetricView",1,0],[0,"ViewBoundary",1,0],[0,"ViewLabels",1,0],[0,"ViewRepresentation",1,0],[1,"ViewScale",0,"Drawings.ViewScaleBuilder",0],[1,"ViewStyle",0,"Drawings.ViewStyleBuilder",0]],[],[]];
SPLM.Drawings.ViewCreationWizardBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewCreationWizardBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewCreationWizardBuilder.Option = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

SPLM.Drawings.ViewCreationWizardBuilder.ViewBoundaryOption = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

SPLM.Drawings.ViewCreationWizardBuilder.ResolutionOption = Object.freeze({
    "Coarse" : "Coarse", "Medium" : "Medium", "Fine" : "Fine"});

SPLM.Drawings.ViewCreationWizardBuilder.ViewRepresentations = Object.freeze({
    "Exact" : "Exact", "SmartLightweight" : "SmartLightweight", "Lightweight" : "Lightweight", "PreNx85Exact" : "PreNx85Exact"});

export default SPLM;